import 'lodash/toString';
import minLength from './min-length.js';
import maxLength from './max-length.js';
var lengthInRange = function lengthInRange(_a) {
  var _b = _a.from,
    from = _b === void 0 ? 0 : _b,
    _c = _a.to,
    to = _c === void 0 ? 0 : _c,
    _d = _a.messageBeforeFrom,
    messageBeforeFrom = _d === void 0 ? 'Недопустимая длина' : _d,
    _e = _a.messageAfterTo,
    messageAfterTo = _e === void 0 ? 'Превышена максимальная длина' : _e;
  return function (value) {
    return minLength({
      limit: from,
      message: messageBeforeFrom
    })(value) || maxLength({
      limit: to,
      message: messageAfterTo
    })(value);
  };
};
export default lengthInRange;
export { lengthInRange };